import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class PaperclipIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 15 32"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M 12.389283,29.69537 C 11.116023,30.950547 9.376986,31.587359 7.644841,31.576683 4.285915,31.5563 0.87184459,29.107096 0.84328729,24.465946 0.82654779,21.748818 0.75761579,10.857011 0.72314939,5.4217873 0.71131999,3.4919379 1.568051,1.8960261 3.074693,1.0456498 4.554747,0.20789318 6.473992,0.22051284 7.964878,1.0747718 c 1.518458,0.8717324 2.396839,2.4773518 2.409643,4.4062303 l 0.115208,18.2141659 c 0.0068,1.039672 -0.271786,1.933728 -0.803543,2.58219 C 9.159355,26.920968 8.406035,27.28694 7.613325,27.282084 6.175616,27.270564 4.713287,26.03079 4.699501,23.675754 L 4.618751,10.883221 c -0.0029,-0.525175 0.426389,-0.9484217 0.95913,-0.9455094 0.53274,0.00291 0.967993,0.4319844 0.970947,0.9571594 l 0.08075,12.794474 c 0.0059,1.10471 0.493351,1.686192 0.971933,1.690073 0.208763,0 0.414571,-0.107759 0.57607,-0.307728 0.250121,-0.302871 0.384043,-0.797957 0.382074,-1.388171 L 8.44543,5.4703243 C 8.437551,4.2199994 7.928444,3.242455 7.012641,2.7182505 6.109641,2.2008411 4.94864,2.1940461 4.052533,2.6988355 3.143624,3.212362 2.646334,4.1860233 2.654212,5.4363484 2.689662,10.872544 2.758591,21.762409 2.774349,24.480504 c 0.02265,3.548087 2.535688,5.180887 4.858674,5.195449 2.32397,0.0136 4.816328,-1.585231 4.792695,-5.136231 L 12.305581,5.4955638 c -0.0029,-0.525175 0.426391,-0.9484218 0.95913,-0.9455094 0.532742,0.00291 0.967995,0.4319833 0.971933,0.9581293 l 0.120134,19.0441553 c 0.01279,2.243401 -0.774001,3.966481 -1.967495,5.143031 z"
					id="path3"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5,
						stroke: "#000000",
						strokeWidth: 0.5,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}